module.exports = __webpack_public_path__ + "img/st-crossicon.9caf4457.svg";